
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesItemsSelectGrid extends _Ext.GridBase<POSSalesItemsRow, any> {
        poscustomerid: any;
        protected getColumnsKey() { return 'Retail.POSSalesItemsSelect'; }
        protected getDialogType() { return <any>POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return POSSalesSelectItemsService.baseUrl; }
     
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);


            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).POSCustomerId = poscustomerid;
            }

            this.poscustomerid = options.GridFilters.CustomerId;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }


        private autoSize;



        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): POSSalesItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }
     
}